export enum CPRouterPaths {
    indexPage = '/customer-portal',
    homePage = '/',
    profilePage = '/profile',
    editProfilePage = '/edit-profile',
    changePasswordPage = '/change-password',
    quotesPage = '/quotes',
    htchHelpPage = '/quotes/help',
    singleQuotePage = '/quotes/:quoteUid',
    shareQuotePage = '/quotes/share/:quoteType/:quoteHash/:quoteUid',
    createHTCHQuotePage = '/create-htct-quote',
    companyInfoPage = '/company-info',
    createAddressPage = '/create-address',
    editAddressPage = '/edit-address',
    authPage = '/auth',
}

export enum CPTutQuoteRouterPaths {
    indexPage = '/tutquote',
    homePage = '',
    quotesPage = 'quotes',
    createQuotePage = 'quotes/create',
    quoteDetailPage = 'quotes/:quoteUid',
    editQuotePage = 'quotes/:quoteUid/edit',
    quoteOrderPage = 'quotes/:quoteUid/order',
    createQuoteItemPage = 'quotes/:quoteUid/items/create',
    editQuoteItemPage = 'quotes/:quoteUid/items/:itemUid/edit',
    usersPage = 'users',
    poLookupPage = 'po-lookup',
    helpPage = 'help',
}
